// Enhance Shopify's rendered policy body; never supply or replace policy content.
const root = document.querySelector('.cdaily-policy-page .shopify-policy__container');
const body = root?.querySelector('.shopify-policy__body');
const headings = [...(body?.querySelectorAll('h2') ?? [])].filter(heading => heading.textContent.trim());

if (root && body && headings.length && !root.hasAttribute('data-cdp-toc')) {
  const nav = document.createElement('nav');
  nav.className = 'cdp-toc';
  nav.setAttribute('aria-label', 'On this page');
  const label = document.createElement('p');
  label.className = 'cdp-toc__label';
  label.textContent = 'ON THIS PAGE';
  const toggle = document.createElement('button');
  toggle.type = 'button';
  toggle.className = 'cdp-toc__toggle';
  toggle.setAttribute('aria-expanded', 'false');
  const list = document.createElement('ul');
  list.className = 'cdp-toc__links';
  let listId = 'cdaily-policy-contents';
  while (document.getElementById(listId)) listId += '-nav';
  list.id = listId;
  toggle.setAttribute('aria-controls', listId);
  toggle.innerHTML = 'ON THIS PAGE <svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="m4 6 4 4 4-4" stroke="currentColor" stroke-width="1.5"/></svg>';
  const links = headings.map((heading) => {
    if (!heading.id) {
      const slug = heading.textContent.trim().normalize('NFKD').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-|-$/g, '') || 'section';
      let id = `cdp-${slug}`;
      let suffix = 2;
      while (document.getElementById(id)) id = `cdp-${slug}-${suffix++}`;
      heading.id = id;
    }
    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = `#${encodeURIComponent(heading.id)}`;
    link.textContent = heading.textContent.trim();
    item.append(link);
    list.append(item);
    link.addEventListener('click', (event) => {
      if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      toggle.setAttribute('aria-expanded', 'false');
      if (!heading.hasAttribute('tabindex')) heading.tabIndex = -1;
      heading.focus({ preventScroll: true });
      heading.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      history.pushState(null, '', link.hash);
    });
    return link;
  });
  nav.append(label, toggle, list);
  body.before(nav);
  root.setAttribute('data-cdp-toc', '');
  toggle.addEventListener('click', () => toggle.setAttribute('aria-expanded', String(toggle.getAttribute('aria-expanded') !== 'true')));
  let frame;
  const update = () => {
    frame = undefined;
    const headerHeight = document.querySelector('#header-component')?.getBoundingClientRect().height ?? 80;
    let active = 0;
    headings.forEach((heading, index) => { if (heading.getBoundingClientRect().top <= Math.max(80, headerHeight) + 48) active = index; });
    links.forEach((link, index) => {
      if (index === active) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  // Capture handles both Tinker's desktop .page-wrapper and native document scrolling.
  document.addEventListener('scroll', schedule, { capture: true, passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  update();
}
